import _ from 'lodash';

export function paginate(items, pageNumber, pageSize) { //maybe add some default values
   const startIndex = (pageNumber -1) * pageSize;
   return _(items).slice(startIndex).take(pageSize).value();
}